import { ReviewLevel } from '@scale/shared-types';

export const REVIEW_LEVELS = [
  {
    level: ReviewLevel.Attempt,
    name: 'Attempt (L-negative-1)',
  },
  {
    level: ReviewLevel.Normal,
    name: 'Review Level 0 (L0)',
  },
  {
    level: ReviewLevel.Level1,
    name: 'Review Level 1 (L1)',
  },
  {
    level: ReviewLevel.ReviewConsensus,
    name: 'Consensus (L4)',
  },
  {
    level: ReviewLevel.Corp,
    name: 'Corp (L10)',
  },
] as const;
